import { defineComponent, createBlock, openBlock, unref, normalizeProps, guardReactiveProps, withCtx, renderSlot } from "vue";
import { TooltipProvider_default } from "../../../../node_modules/.pnpm/reka-ui@2.5.1_patch_hash_1a_fe91be2ae044c59728f130150abaf78d/node_modules/reka-ui/dist/Tooltip/TooltipProvider.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TooltipProvider",
  props: {
    delayDuration: { default: 0 },
    skipDelayDuration: {},
    disableHoverableContent: { type: Boolean },
    disableClosingTrigger: { type: Boolean },
    disabled: { type: Boolean },
    ignoreNonKeyboardFocus: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => (openBlock(), createBlock(unref(TooltipProvider_default), normalizeProps(guardReactiveProps(props)), {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=TooltipProvider.vue.js.map
